

//export const API_URL = process.env.REACT_APP_ApiUrl;
//export const API_URL_SERN = process.env.REACT_APP_ApiUrl_SERN;
//export const SHOW_IMAGE_BASE_PATH = process.env.REACT_APP_ApiUrl_SERN + '/api/';
//export const MAP_API_KEY = 'AIzaSyBeSEd28jj7f1LpDCjI-ZowhKp1e8z3q4A';

export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_SERN = process.env.REACT_APP_API_URL_SERN;
export const SHOW_IMAGE_BASE_PATH = process.env.REACT_APP_API_URL_SERN + "/api/";
export const MAP_API_KEY = process.env.REACT_APP_MAP_API_KEY;
